import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core//DialogActions';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import MenuButton from './buttons/MenuButton';

import MyDetails from './accounts/mydetails';
import UserAdmin from './accounts/users';
import Dashboard from './accounts/dashboard';

import { UserContext } from "../context/user-context";


const useStyles = makeStyles({
  root: {
    flexGrow: 1,

  },
  containerDiv: {
    border: '1px solid #D2D2D8',
  },
  dialogPaper: {
    minHeight: '80vh',
    maxHeight: '60vh',
    '& .MuiDialogContent-root': {
      overflowY: 'hidden'
    }
  },
  closeButton: {
    height: 28,
    width: 180,
    backgroundColor:'#0C4C35',
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#63D764'
    },
  },

});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function AccountDialog(props) {

  const classes = useStyles();
  const [uState] = useContext(UserContext);
  const [open, setOpen] = useState(false);
  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState('lg');
  const [value, setValue] = useState(0);
  const [isManager, setIsManager] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    const userType = uState.user.userutype;
    switch (userType){
      case "admin":
      case "manager":
        setIsManager(true);
      break;
      default:
        setIsManager(false);
      break;
    }

    if (uState.company.companytype == 'training') { setIsDisabled(true); };

  },[uState.user.userutype]);



  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSubmit = () => {
    setOpen(true);
  };

  return (
    <div className={classes.root}>
        <MenuButton label="My Account" handleClick={handleSubmit} disabled={isDisabled} tooltip={''} />
        <Dialog open={open} classes={{ paper: classes.dialogPaper }} onClose={e => setOpen(false)} aria-labelledby="form-dialog-title" fullWidth={fullWidth} maxWidth={maxWidth}>
          <DialogContent>
              <Tabs
                value={value}
                indicatorColor="primary"
                textColor="primary"
                onChange={handleChange}
                aria-label="My account options"
              >
                <Tab label="Dashboard" {...a11yProps(0)} />
                <Tab label="Users" {...a11yProps(1)} disabled={!isManager} />
                <Tab label="Company" {...a11yProps(2)} disabled={!isManager} />
              </Tabs>
              <TabPanel value={value} index={0}>
                <Dashboard />
              </TabPanel>
              <TabPanel value={value} index={1}>
                <UserAdmin />
              </TabPanel>
              <TabPanel value={value} index={2}>
                <MyDetails />
              </TabPanel>

          </DialogContent>
          <DialogActions>
            <Button className={classes.closeButton} variant="contained" onClick={e => setOpen(false)}>
                <Box p={1} fontWeight="fontWeightRegular" fontSize={12} >Cancel</Box>
            </Button>
        </DialogActions>
        </Dialog>
    </div>
  );
}
